exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".InterviewResults textarea {\n  margin-top: 24px; }\n\n.InterviewResults:not(.isEditing) table {\n  width: auto; }\n\n.InterviewResults:not(.isEditing) tr {\n  border-bottom: none; }\n\n.InterviewResults td, .InterviewResults th {\n  text-align: center; }\n\n.InterviewResults tbody tr td:first-of-type {\n  font-weight: bold;\n  text-align: left; }\n\n.InterviewResults tbody tr td:not(:first-of-type) {\n  min-width: 80px; }\n\n.InterviewResults .FormField-display {\n  white-space: pre-wrap; }\n\n.InterviewResults .RadioIndicator {\n  border: 1px solid #555;\n  border-radius: 50%;\n  display: inline-block;\n  height: 16px;\n  margin: 0 auto;\n  width: 16px; }\n  .InterviewResults .RadioIndicator.selected {\n    background: #000; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/modules/form/components/input/InterviewResults/InterviewResults.scss
// module id = 1390
// module chunks = 0